import { Stay22DTO, Stay22Data } from "../entity";
import { Stay22Factory } from "../infrastructure";

export class Stay22 {

    public static initialize() {
        const stay22DataElement: HTMLElement | null = document.querySelector('[data-js=stay22-data]');

        if (!stay22DataElement || !stay22DataElement.innerHTML || !stay22DataElement.parentNode) {
            return;
        }

        const data: Stay22DTO = JSON.parse(stay22DataElement.innerHTML);
        const templateData: Stay22Data | null = Stay22Factory.getDataFrom(data);
        stay22DataElement.parentNode.removeChild(stay22DataElement);

        if (!templateData || !templateData.location || templateData.location === ', ') {
            return;
        }

        if (!templateData.fromDate) {
            return console.error('From date is required for Stay22');
        }

        const stay22container: HTMLElement | null = document.querySelector('[data-js=stay22-container]');

        if (stay22container) {
            const markup = this.createMarkupFrom(templateData, stay22container);
            this.embedMarkupTo(stay22container, markup);
        }
    }

    private static createMarkupFrom(templateData: Stay22Data, container: HTMLElement): string {
        const affiliateId = container.getAttribute("data-affiliate-id");
        const country = container.getAttribute("data-country");
        const iFrameSrc = `https://www.stay22.com/embed/gm?aid=${affiliateId}&address=${templateData.location}` +
            `${templateData.fromDate ? '&eventstart=' + templateData.fromDate : ''}` +
            `${templateData.toDate ? '&eventend=' + templateData.toDate : ''}` +
            `&campaign=${country}-${this.getPageName() + 'Page'}`;

        return `
            <div class="m-panel">
                <div class="m-panel__head">
                    <h2 class="m-panel__title">${templateData.header}</h2>
                </div>

                <div class="m-panel__body">
                    <div class="m-panel__row">
                        <h3>${templateData.pitch}</h3>

                        <iframe title="stay22" data-test="stay22-iframe" loading="lazy" src="${iFrameSrc}" width="100%" height="460" frameborder="0">
                        </iframe>
                    </div>
                </div>
            </div>
        `;
    }

    private static embedMarkupTo(container: HTMLElement, markup: string) {
        container.innerHTML = markup;
    }

    private static getPageName(): string {
        const currentUrl = new URL(window.location.href);
        const pathname = currentUrl.pathname ?? '';
        const pathArray = pathname.split('/').pop();

        return pathArray ? pathArray.split('.')[0] : '';
    }
}
